import {TRealtime} from './realtime/realtime.type';
import {TEvent} from './event/event.type';
import {TUser} from './user/user.type';
import {TAuth} from './auth/auth.type';
import {TTickets} from './tickets/tickets.type';
import {TUI} from './ui/ui.type';
import {TForms} from './forms/forms.type';
import {TCategories} from './categories/categories.type';
import {TLanguages} from './languages/languages.type';
import {TTeam} from './team/team.type';
import {TDesign} from './design/design.type';
import {TBranding} from './branding/branding.type';
import {TAttendance} from './attendance/attendance.type';
import {TAccount} from './account/account.type';
import {TMailing} from './mailing/mailing.type';
import {TPromotion} from './promotion/promotion.type';
import {TPreparingEvent} from './preparingEvent/preparingEvent.type';
import {TCashStats} from './cash/cash.type';
import {TManagement} from './management/management.type';
import {TCluster} from './cluster/cluster.type';
import {TCrowds} from './crowds/crowds.type';
import {TPublish} from './publish/publish.type';
import {TRatings} from './ratings/ratings.type';
import {TSecurity} from './security/security.type';
import {TSuggestion} from './suggestions/suggestions.type';
import {TSupplierState} from './supplier/supplier.type';
import store from '../store';
import {TSubscription} from './subscription/subscription.type';
import {TCrm} from './crm/crm.type';

export const getState = () => store.getState() as RootState;

export interface RootState {
    realtime: TRealtime;
    event: TEvent;
    user: TUser;
    auth: TAuth;
    tickets: TTickets;
    ui: TUI;
    forms: TForms;
    categories: TCategories;
    languages: TLanguages;
    team: TTeam;
    design: TDesign;
    branding: TBranding;
    attendance: TAttendance;
    account: TAccount;
    cluster: TCluster;
    crm: TCrm;
    crowds: TCrowds;
    mailing: TMailing;
    preparingEvent: TPreparingEvent;
    promotion: TPromotion;
    cash: TCashStats;
    management: TManagement;
    publish: TPublish;
    ratings: TRatings;
    security: TSecurity;
    suggestions: TSuggestion;
    supplier: TSupplierState;
    subscription: TSubscription;
}
export type TState = RootState;